export default "__VITE_ASSET__65bcd934__"